<template lang="pug">
  hotsite-dgc
    .conteudo
      contato
        p 
          strong FALE ‌‍⁣⁡‍⁡⁢⁡⁤‍⁢‍⁢⁢⁣‍⁢‌⁡‌⁢⁣⁡⁢⁡⁡‌⁤‍⁡⁢‍⁢‌⁤‌⁤⁤⁢⁣‍⁡⁡⁢‌⁢⁣‍⁢⁡⁢‍‌⁤‍‌⁡⁢⁢⁡⁡‍⁣⁢‍⁡‍⁣‌⁢⁡‍⁡⁢⁡⁢⁢‌⁡⁡⁢⁡⁢‍‌⁡⁣‍⁡⁡⁡‍⁡⁡⁡‌⁡‌⁢⁢⁡‍‌⁤‍⁢‍‌‍‌⁡‍⁣‍⁡‌⁡⁤‍⁡⁢‍‌⁢⁡‌‍⁡⁢⁢⁡⁤‍⁣⁣‍⁢⁢‌⁢⁣⁡‌⁢⁡‍⁢⁤‍⁡⁢‍‌⁢⁢⁢‍⁡⁡⁡⁡‍⁡⁢⁤⁢⁤‍⁡‌⁢⁡⁤⁡⁤‌⁡⁤⁢CONOSCO
        ul
          li
            span Telefone institucional: (84) 3342-2328
            | 
            span / Ramais: 306, 307 e 303

          li
            span Telefone institucional (celular): (84) 99193-6296

          li
            span E-mail para contato:
            | 
            a(href="dgc@reitoria.ufrn.br") dgc@reitoria.ufrn.br
      localizacao
        p Texto com o endereço da unidade...
</template>

<script>
  import Contato from 'MODULES/HotsiteContato'
  import Localizacao from 'MODULES/HotsiteMapa'
  import HotsiteDgc from 'PAGES/dgc/Base'

  export default {
    components: {
      Contato,
      Localizacao,
      HotsiteDgc
    }
  }
</script>



// WEBPACK FOOTER //
// Contato.vue?a6796e4e